import React, { useEffect, useRef, useState } from "react";

const AutoSizeTextCanvas = ({ text, textColor, bgColor, maxWidth: customMaxWidth }) => {

  const canvasRef = useRef(null);
  const fontFamily = "Inter";
  const fontSize = 14;
  const lineHeight = 1.8;
  const padding = 5;
  const maxWidth = customMaxWidth || 600;
  const dpr = window.devicePixelRatio || 1;

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    if (!text || text.trim() === "") {
      canvas.width = 250;
      canvas.height = 20;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      return;
    }

    ctx.font = `bold ${fontSize}px ${fontFamily}`;
    ctx.textBaseline = "top";

    const paragraphs = text?.split("\n");
    const wrappedLines = [];
    paragraphs?.forEach((p) => {
      const words = p?.split(" ");
      let line = "";
      words.forEach((word) => {
        const testLine = line ? line + " " + word : word;
        const { width } = ctx?.measureText(testLine);
        if (width > maxWidth && line) {
          wrappedLines?.push(line);
          line = word;
        } else {
          line = testLine;
        }
      });
      wrappedLines?.push(line);
    });

    const lineHeightPx = fontSize * lineHeight;
    const textWidth = Math.min(
      maxWidth,
      Math.max(...wrappedLines?.map((l) => ctx.measureText(l).width))
    );
    const textHeight = wrappedLines?.length * lineHeightPx;

    canvas.width = (textWidth + padding * 2) * dpr;
    canvas.height = (textHeight + padding) * dpr;
    canvas.style.width = (textWidth + padding * 2) + "px";
    canvas.style.height = (textHeight + padding) + "px";

    ctx.scale(dpr, dpr);
    ctx.font = `bold ${fontSize}px ${fontFamily}`;
    ctx.textBaseline = "top";
    ctx.fillStyle = textColor || "#222";

    wrappedLines.forEach((line, i) => {
      ctx.fillText(line, padding, padding + i * lineHeightPx);
    });
  }, [text, textColor, bgColor, maxWidth]);

  return (
      <canvas
        ref={canvasRef}
        style={{
          display: "inline-block",
          maxWidth: "100%",
        }}
      />
  );
};
export default AutoSizeTextCanvas;